import React, { FC } from 'react'
import { HStack, Typography, XelaColor } from '@/XelaReact'
import { router } from '@inertiajs/react'
import Notification = App.Models.Notification

const AdmissionApplicationFeePaidNotification: FC<{
  notification: Notification
  portal?: string
}> = ({ notification, portal = 'Agency' }) => {
  return (
    <HStack
      spacing="3px"
      style={{
        flexWrap: 'wrap',
        cursor: 'pointer',
        padding: '12px',
      }}
      onClick={() => {
        if (portal === 'Agency') {
          router.visit(`/admissions/${notification.data.admission_id}`)
        } else {
          if (portal === 'B2B') {
            router.visit(`/b2b/leads/${notification.data.lead_id}`)
          }
        }
      }}
    >
      <Typography variant="body-small-bold" color={XelaColor.Orange3}>
        #{notification.data.lead_name}
      </Typography>
      <Typography variant="body-small" color={XelaColor.Gray6}>
        has paid tuition fee for university
      </Typography>
      <Typography variant="body-small-bold">{notification.data.university_name},</Typography>
      <Typography variant="body-small" color={XelaColor.Gray6}>
        processed by
      </Typography>
      <Typography variant="body-small-bold">{notification.data.event_by}</Typography>
    </HStack>
  )
}

export default AdmissionApplicationFeePaidNotification
